<template>
  <div class="w100 bg-w" v-loading="">
    <p class="w100 pl20 pt20 font-16">服务主题</p>
    <div class="w100 pt10 pb20 pr20 tx-r">
      <el-button type="warning" @click="selData = { name: '' }, isNew = true, isShow = true">新增主题 ＋</el-button>
      <el-button @click="fetchData" :loading="loading">刷新</el-button>
    </div>

    <section class="pl20 pr20 pb20" v-loading="loading">
      <el-table class="w100 tx-c my-table" :data="tableData" stripe border height="500">
        <el-table-column align="center" label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ ((page - 1) * size) + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务主题名称" prop="name"></el-table-column>
        <el-table-column align="center" label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | filterDate('yyyy-MM-dd') }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="更新时间">
          <template slot-scope="scope">
            <span v-if="scope.row.updateTime">{{ scope.row.updateTime | filterDate('yyyy-MM-dd') }}</span>
            <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <span class="ml10 mr10 blue cu-p font-14" @click="selData.id = scope.row.id, selData.name = scope.row.name, isNew = false, isShow = true"><i class="el-icon-edit"></i></span>
            <span class="ml10 mr10 red cu-p font-14" @click="clickDeleteRow(scope.row.id)"><i class="el-icon-delete"></i></span>
          </template>
        </el-table-column>
      </el-table>

      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </section>

    <el-dialog :visible.sync="isShow" :close-on-click-modal="!updataing" :close-on-press-escape="!updataing" :show-close="!updataing" width="300px">
      <span class="font-16" slot="title">{{ selData.id ? '修改主题' : '新增主题' }}</span>
      <div class="w100 tx-c">
        <el-input placeholder="请输入主题名称" v-model="selData.name"></el-input>
      </div>
      <span slot="footer">
        <el-button @click="isShow = false" :loading="updataing">取 消</el-button>
        <el-button type="primary" :disabled="selData.name == ''" :loading="updataing" @click="cilckUpdata">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OfficeSubject",
  props: [],
  data() {
    return {
      loading: false,

      tableData: [],
      page: 1,
      size: 30,
      total: 0,

      isShow: false,
      isNew: false,
      updataing: false,
      selData: {
        name: ""
      }
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  created() {},
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;

      this.$http
        .post(
          "serveTitle/query",
          this.$qs.stringify({
            name: "",
            userId: this.userData.userId,
            pageNum: this.page,
            pageSize: this.size
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.tableData = data.resData.list;
            this.total = data.resData.total;
          } else {
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    cilckUpdata() {
      if (this.isNew) {
        this.updataing = true;

        this.$http
          .post(
            "serveTitle/add",
            this.$qs.stringify({
              userId: this.userData.userId,
              name: this.selData.name
            })
          )
          .then(({ data }) => {
            // console.log(data.resData);
            if (data.resStatus == 0 && data.resCode == 0) {
              this.$message({
                message: data.resMsg,
                type: "success"
              });
              this.isShow = false;
              this.fetchData();
            } else {
              this.$message({
                message: data.resMsg,
                type: "error"
              });
            }
            this.updataing = false;
          })
          .catch(() => {
            this.$message({
              message: "网络请求错误，请检查网络",
              type: "error"
            });
            this.updataing = false;
          });
      } else {
        this.updataing = true;

        this.$http
          .post(
            "serveTitle/update",
            this.$qs.stringify({
              userId: this.userData.userId,
              id: this.selData.id,
              name: this.selData.name
            })
          )
          .then(({ data }) => {
            // console.log(data.resData);
            if (data.resStatus == 0 && data.resCode == 0) {
              this.$message({
                message: data.resMsg,
                type: "success"
              });
              this.fetchData();
            } else {
              this.$message({
                message: data.resMsg,
                type: "error"
              });
            }
            this.updataing = false;
            this.isShow = false;
          })
          .catch(() => {
            this.$message({
              message: "网络请求错误，请检查网络",
              type: "error"
            });
            this.updataing = false;
            this.isShow = false;
          });
      }
    },
    clickDeleteRow(id) {
      this.$confirm("是否删除该主题", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;

          this.$http
            .post(
              "serveTitle/delete",
              this.$qs.stringify({
                userId: this.userData.userId,
                id: id
              })
            )
            .then(({ data }) => {
              // console.log(data.resData);
              if (data.resStatus == 0 && data.resCode == 0) {
                this.$message({
                  message: data.resMsg,
                  type: "success"
                });
                this.fetchData();
              } else {
                this.$message({
                  message: data.resMsg,
                  type: "error"
                });
              }
              this.loading = false;
            })
            .catch(() => {
              this.$message({
                message: "网络请求错误，请检查网络",
                type: "error"
              });
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    changeSize(value) {
      this.size = value;
      this.fetchData();
    },
    changePage(value) {
      this.page = value;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
</style>
